import React, { useState } from 'react';
import { toast } from 'react-toastify';

const N  = '#0A2540';
const E  = '#7C4DFF';
const ED = '#6030E8';

const contactInfo = [
  { icon: 'fas fa-envelope',    label: 'Email',    value: 'info@moneyconstant.com',        href: 'mailto:info@moneyconstant.com' },
  { icon: 'fas fa-phone',       label: 'Phone',    value: '0793 006 480',                  href: 'tel:+254793006480' },
  { icon: 'fas fa-map-marker-alt', label: 'Location', value: 'Nairobi, Kenya',             href: '#' },
  { icon: 'fab fa-linkedin',    label: 'LinkedIn', value: 'linkedin.com/in/denniskuria',   href: 'https://www.linkedin.com/in/denniskuria/' },
  { icon: 'fas fa-globe',       label: 'Website',  value: 'Moneyconstant.com',             href: 'https://moneyconstant.com' },
];

const inputStyle = {
  width: '100%', padding: '12px 14px', borderRadius: 8,
  background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.14)',
  color: '#fff', fontSize: '0.9rem', fontFamily: 'inherit', outline: 'none',
  boxSizing: 'border-box',
};

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Please fill all required fields');
      return;
    }
    setSending(true);
    await new Promise(r => setTimeout(r, 1000));
    toast.success('Message sent! Dennis will get back to you shortly.');
    setForm({ name: '', email: '', subject: '', message: '' });
    setSending(false);
  };

  return (
    <section id="contact" className="section" style={{ background: N }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <div style={{
            display: 'inline-block', background: 'rgba(255,255,255,0.10)',
            color: 'rgba(255,255,255,0.80)', padding: '4px 14px', borderRadius: 20,
            fontSize: '0.78rem', fontWeight: 700, marginBottom: 12, letterSpacing: '1px',
            border: '1px solid rgba(255,255,255,0.18)',
          }}>
            GET IN TOUCH
          </div>
          <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: '2.2rem', color: '#fff', fontWeight: 800 }}>
            Get In Touch
          </h2>
          <div style={{ width: 60, height: 4, background: E, borderRadius: 2, margin: '14px auto 0' }} />
          <p style={{ color: 'rgba(255,255,255,0.45)', marginTop: 16, maxWidth: 500, margin: '16px auto 0' }}>
            Available for consulting, program design, research engagements, and speaking opportunities.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 48, alignItems: 'start' }}>
          {/* Contact info */}
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {contactInfo.map(c => (
                <a key={c.label} href={c.href} target={c.href.startsWith('http') ? '_blank' : '_self'} rel="noreferrer"
                  style={{
                    display: 'flex', alignItems: 'center', gap: 16, padding: 18,
                    background: 'rgba(255,255,255,0.05)', borderRadius: 10,
                    border: '1px solid rgba(255,255,255,0.08)', textDecoration: 'none',
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(124,77,255,0.45)'; e.currentTarget.style.background = 'rgba(124,77,255,0.07)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
                >
                  <div style={{
                    width: 44, height: 44, borderRadius: 10,
                    background: 'rgba(124,77,255,0.15)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                  }}>
                    <i className={c.icon} style={{ color: E, fontSize: '1rem' }} />
                  </div>
                  <div>
                    <div style={{ color: 'rgba(255,255,255,0.38)', fontSize: '0.75rem', marginBottom: 2 }}>{c.label}</div>
                    <div style={{ color: '#fff', fontSize: '0.9rem', fontWeight: 500 }}>{c.value}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Contact form */}
          <form onSubmit={handleSubmit} style={{
            background: 'rgba(255,255,255,0.05)', borderRadius: 16,
            border: '1px solid rgba(255,255,255,0.10)', padding: 32,
          }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              {['name', 'email'].map(field => (
                <div key={field}>
                  <label style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: 6 }}>
                    {field === 'name' ? 'Full Name *' : 'Email *'}
                  </label>
                  <input
                    type={field === 'email' ? 'email' : 'text'}
                    name={field}
                    value={form[field]}
                    onChange={handleChange}
                    placeholder={field === 'name' ? 'John Doe' : 'john@example.com'}
                    style={inputStyle}
                  />
                </div>
              ))}
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: 6 }}>Subject</label>
              <input
                type="text" name="subject" value={form.subject} onChange={handleChange}
                placeholder="How can I help you?"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.82rem', fontWeight: 600, display: 'block', marginBottom: 6 }}>
                Message *
              </label>
              <textarea
                name="message" value={form.message} onChange={handleChange} rows={5}
                placeholder="Tell me about your project or inquiry..."
                style={{ ...inputStyle, resize: 'vertical' }}
              />
            </div>

            <button type="submit" disabled={sending} style={{
              width: '100%', padding: '14px', background: E, color: '#fff',
              border: 'none', borderRadius: 8, fontWeight: 700, fontSize: '1rem',
              cursor: sending ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
              opacity: sending ? 0.7 : 1, transition: 'all 0.2s',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              boxShadow: '0 4px 18px rgba(124,77,255,0.30)',
            }}
              onMouseEnter={e => { if (!sending) { e.currentTarget.style.background = ED; e.currentTarget.style.transform = 'translateY(-1px)'; } }}
              onMouseLeave={e => { e.currentTarget.style.background = E; e.currentTarget.style.transform = 'none'; }}
            >
              {sending
                ? <><i className="fas fa-spinner fa-spin" /> Sending...</>
                : <><i className="fas fa-paper-plane" /> Send Message</>}
            </button>
          </form>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #contact .container > div:last-child { grid-template-columns: 1fr !important; }
        }
        input::placeholder, textarea::placeholder { color: rgba(255,255,255,0.22) !important; }
        input:focus, textarea:focus {
          border-color: rgba(124,77,255,0.50) !important;
          box-shadow: 0 0 0 3px rgba(124,77,255,0.12) !important;
        }
      `}</style>
    </section>
  );
}
